/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import { IChallengeDeclaration } from 'interfaces';
import { ProductsDetailsList } from 'components/ProductsDetailsList';
import { TProductDetails } from 'interfaces/challenge.types';
import { RESULT_STATUS } from 'constants/index';

export default function ProductsDetail({
  challengeProductDeclarations: products,
  isGoalMecanicByProduct,
  isCurrencyValuesRequired,
  unitToDisplay,
  status,
}: IChallengeDeclaration & {
  isGoalMecanicByProduct: boolean;
  isMobile: boolean;
  unitToDisplay: string;
}): JSX.Element {
  const formattedProductsToList: TProductDetails[] = products.map((product) => {
    return { ...product, financialValue: product.value };
  });
  const isValidatedDeclaration = status === RESULT_STATUS.VALIDATED;

  return (
    <React.Fragment>
      <ProductsDetailsList
        rowsPerPage={10}
        productDetailsList={formattedProductsToList}
        displayFinancialValues={isCurrencyValuesRequired}
        displayGainValues={isValidatedDeclaration}
        isGoalMecanicByProduct={isGoalMecanicByProduct}
        unitToDisplay={unitToDisplay}
        withHeaderFieldsDescription
      />
    </React.Fragment>
  );
}
